import React from "react";
import { CalendarIcon } from "@heroicons/react/24/outline";
import { convertToBrazilDate } from "../../../helpers/date";

const PostTitle = ({ title }) => (
  <h3 className="text-left text-sm font-bold text-white uppercase group-hover:underline">
    {title}
  </h3>
);

const CompactPostDate = ({ date }) => (
  <div className="flex flex-row gap-1">
    <CalendarIcon className="size-4 text-gray-400" />
    <span className="text-gray-400 text-xs text-left w-full">
      {convertToBrazilDate(date)}
    </span>
  </div>
);

const PostItem = ({ id, title, published_at }) => (
  <a href={`/blog/post/${id}`} key={`post-${id}`} className="group">
    <PostTitle title={title} />
    <CompactPostDate date={published_at} />
  </a>
);

export function SidebarPosts({ posts }) {
  return (
    <div className="flex flex-col w-full gap-4">
      {posts?.map((post) => (
        <PostItem key={post.id} {...post} />
      ))}
    </div>
  );
}
